import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AuthenticationService } from '../_services/authentication.service';
import { MessageService } from '../message/message.service';

@Component({
	selector: 'app-forgotpassword',
	templateUrl: './forgotpassword.component.html',
	styleUrls: ['../auth-layout/auth-layout.component.css'],
})
export class ForgotpasswordComponent implements OnInit, OnDestroy {
	forgotPasswordForm;

	constructor(
		private auth: AuthenticationService,
		private message: MessageService,
		private form: FormBuilder
	) {
		this.forgotPasswordForm = this.form.group({
			email: '',
		});
	}

	ngOnInit() {
		document.body.classList.add('login-page');
	}

	ngOnDestroy() {
		document.body.classList.remove('login-page');
	}

	reset() {
		var formData: any = new FormData();
		formData.append('email', this.forgotPasswordForm.get('email').value);
		console.log(formData);
		this.auth.resetPasswordRequest(formData).subscribe(
			(data) => {
				this.message.sendMessage(data);
			},
			(error) => {
				// Handle error
			}
		);
	}
}
